import styled from "@emotion/styled";

export const Form = styled("form")``;
